import React from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { activateManagedConversation } from '../../../actions/conversations/activateManagedGroupChat'


export const NewManagedConversationModal = ({ show, handleClose, recipients, conversationOptions }) => {
  const dispatch = useDispatch()
  const [ confirmingOption, setConfirmingOption ] = React.useState()

  function confirm(option) {
    setConfirmingOption(option)
  }

  function onClose(){
    setConfirmingOption(undefined)
    handleClose()
  }


  function activate(value) {
    dispatch(activateManagedConversation(value)).then(onClose)
  }



  return(
    <Modal show={show} onHide={onClose} size="lg">
      {
        !!confirmingOption ? 
        <ConfirmingOption {...{
          activate,
          confirmingOption,
          handleClose: onClose,
          setConfirmingOption,
        }}/> :
        <ConversationOptionsList {...{
          confirm,
          conversationOptions,
          handleClose: onClose,
        }}/>
      }
    </Modal>
  )
}

const ConversationOptionsList = ({ handleClose, conversationOptions, confirm }) => (
  <>
    <div className="pl-4 pr-4 pt-3 pb-3 card-header d-flex justify-content-between align-items-center">
      <>Add Group Message</>
      <div className="btn btn-primary btn-sm" onClick={handleClose}><div className="fas fa-times" /></div>
    </div>
    <div >
      {
        conversationOptions.map(option=>(
          <div className="p-4 d-flex justify-content-between align-items-center border-bottom hoverable">
            <b>{option.label}</b>
            <div onClick={()=>confirm(option)} className="btn btn-outline-primary">
              Activate
            </div>
          </div>
        ))
      }
    </div>
  </>
)

const ConfirmingOption = ({ confirmingOption, setConfirmingOption, activate, handleClose }) => (
  <>
    <div className="pl-4 pr-4 pt-3 pb-3 card-header d-flex justify-content-between align-items-center">
      <>Confirm Activation Of { confirmingOption.label }</>
      <div className="btn btn-primary btn-sm" onClick={handleClose}><div className="fas fa-times" /></div>
    </div>
    <div className="p-4">
      <div className="pb-4">Are you sure you want to create a group message for {confirmingOption.label}?</div>
      {
        confirmingOption.value.kind == 'admitted' &&
        <b>Upon enabling this group message all active clients from {confirmingOption.value.group_name} will be added to the group message.</b>
      }
      {
        confirmingOption.value.kind == 'alumni' &&
        <b>Upon enabling this group message, all clients from {confirmingOption.value.group_name} with a normal transition in their occupancy will be added to this group message.</b>
      }
      <div className="pt-4 d-flex justify-content-between">
        <div onClick={()=>setConfirmingOption(undefined)} className="btn btn-outline-danger">Go Back</div>
        <div onClick={()=>activate(confirmingOption.value)} className="btn btn-primary">Confirm</div>
      </div>
    </div>
  </>
)